/*
  Lily & June card quick add (operator 27-10-2026, "net als Sableau"): the bag button on a product card adds the piece
  without opening the cart drawer. The shopper stays on the grid and sees an "Added to bag" band on the card and the
  photo flying into the bag icon (port of Sableau's assets/tr-card.js, theme-tr-2026-10).
  "?partial=true" is a URL the Essential drawer's fetch hook skips, so it stays closed; refreshCart() then updates its
  contents while closed. Pieces with options keep linking to the product page (snippets/lj-card.liquid).
*/
(function () {
  if (window.__ljCardAdd) return;
  window.__ljCardAdd = true;
  var EASE = 'cubic-bezier(.22,1,.36,1)';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function icon() {
    var all = document.querySelectorAll('.header-actions__cart-icon, .header-actions__action.action__cart');
    for (var i = 0; i < all.length; i++) if (all[i].getBoundingClientRect().width) return all[i];
    return null;
  }
  function bump(el) { if (el && !still) el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 450, easing: EASE }); }

  // The header count: the theme only redraws it on its own cart events, so set it from /cart.js (protection line excluded, as in the drawer title).
  function count() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var n = c.items.filter(function (i) { return i.product_type !== 'Order Upsell'; }).reduce(function (s, i) { return s + i.quantity; }, 0);
      document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) { el.textContent = n; el.classList.toggle('hidden', !n); });
      document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', !n); });
    }).catch(function () {});
  }

  function added(wrap) {
    var m = wrap.querySelector('.lj-card__media'), ok = document.createElement('div');
    ok.className = 'lj-card__ok'; ok.setAttribute('role', 'status');
    ok.innerHTML = CHECK + '<span></span>';
    ok.lastChild.textContent = window.LJ_I18N.added_to_bag;
    m.appendChild(ok);
    if (!still) ok.animate([{ transform: 'translateY(100%)' }, { transform: 'none' }], { duration: 320, easing: EASE });
    setTimeout(function () { ok.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 250, fill: 'forwards' }).onfinish = function () { ok.remove(); }; }, 1600);
    var img = m.querySelector('img'), to = icon();
    if (still || !img || !to) return bump(to);
    var a = img.getBoundingClientRect(), b = to.getBoundingClientRect(), s = 64, f = document.createElement('div');
    f.className = 'lj-fly';
    f.style.cssText = 'left:' + (a.left + a.width / 2 - s / 2) + 'px;top:' + (a.top + a.height / 2 - s / 2) + 'px;background-image:url("' + (img.currentSrc || img.src) + '")';
    document.body.appendChild(f);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    f.animate([
      { transform: 'none' },
      { transform: 'translate(' + dx * .35 + 'px,' + (dy * .35 - 40) + 'px) scale(.8)', offset: .4 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.2)', opacity: .6 }
    ], { duration: 700, easing: 'cubic-bezier(.5,0,.75,0)' }).onfinish = function () { f.remove(); bump(to); };
  }

  // Klaviyo "Added to Cart" for card adds: the product-page tracker only sees the product form (as Sableau, review 07-10 M5).
  function klAdd(i) {
    try {
      var k = window.klaviyo || (window._klOnsite = window._klOnsite || []);
      k.push(['track', 'Added to Cart', { $value: i.final_line_price / 100, ProductName: i.product_title, ProductID: i.product_id, VariantID: i.variant_id,
        Quantity: i.quantity, Price: i.final_price / 100, ImageURL: i.image, URL: location.origin + i.url }]);
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-lj-qa]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.lj-card-wrap');
    if (btn.disabled || !wrap) return;   // a double tap adds once
    btn.disabled = true;
    fetch('/cart/add.js?partial=true', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: +btn.dataset.ljQa, quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (i) {
        added(wrap);
        klAdd(i);
        if (window.essentialCartApi) window.essentialCartApi.refreshCart();
        count();
      })
      .catch(function () { location.href = wrap.querySelector('.lj-card').href; })
      .then(function () { btn.disabled = false; });
  });
})();
